<template>
    <div class="label-form">
        <input type="text" name="label-like" placeholder="Search labels" v-model="searchText" @input="labelSearch" class="form-control"/>
        <div class="label-list" style="overflow: auto; height: 170px; margin-top: 10px;">
            <table border="0" cellspacing="0" cellpadding="0" style="width: 100%;">
                <tr v-for="label in filteredLabels" :key="label.id">
                    <td style="width: 30px;">
                        <input type="checkbox" :id="'label_' + label.id" :value="label" @change="checkLabel(label, $event)" :checked="isChecked(label)"/>
                    </td>
                    <td>
                        <label :for="'label_' + label.id">{{ label.label_name }}</label>
                    </td>
                </tr>
            </table>
        </div>
    </div>
</template>

<script>
import {EventBus} from "@/events/event-bus";
import {getLabels} from "@/modules/common/api";

export default {
    name: 'CommonLabelTemplate',
    props:{
        value: [],
        modalId:null,
        allLabels:null
    },
    data() {
        return {
            searchText: '',
            labels:[],
            selected: [...this.value],
            temp: [...this.value]
        };
    },
    computed: {
        filteredLabels() {
            return this.labels.filter(label => label.label_name.toLowerCase().includes(this.searchText.toLowerCase()));
        }
    },
    mounted() {

        EventBus.$on('onModalConfirmed',()=>{
            this.$emit('input',this.selected)
        })
        $(`#${this.modalId}`).on('shown.bs.modal',()=>{
            this.selected = [...this.value]
        })
        if(this.allLabels)
          this.labels = this.allLabels
        else{
            getLabels().then((response) => {
              this.labels =  response.data;
            });
        }

    },
    methods: {
        labelSearch() {
            // Handle the input event if needed
        },
        checkLabel(selectedLabel, event) {
            const index = this.selected .findIndex(label => label.id === selectedLabel.id);
            if (index !== -1) {
                // Label is already in selectedLabels, so remove it
                this.selected .splice(index, 1);
            } else {
                // Label is not in selectedLabels, so add it
                this.selected.push(selectedLabel);
            }
        },
        isChecked(label) {
            const selectedLabelsIds = this.selected.map(item => item.id);
            return selectedLabelsIds.includes(label.id);
        }
    },
};
</script>

<style scoped>
/* Your CSS styles */
</style>
